import React from "react";
import "./Product.css";
import product from "../assets/product.jpg";
import product2 from "../assets/product2.png";

const productos = [
  { litros: "5L", rinde: "50 litros", img: product },
  { litros: "10L", rinde: "100 litros", img: product2 },
];

const Product = () => {
  return (
    <div className="product-container">
      <div className="product-header">
        <span>Entregas en Hermosillo, Sonora</span>
        <span className="header-right">Nuestros productos</span>
      </div>

      <div className="product-cards">
        {productos.map((p) => (
          <div className="product-card" key={p.litros}>
            <img
              src={p.img}
              alt={`Lixiviado de Lombriz ${p.litros}`}
              className="product-img"
            />
            <div className="card-content">
              <h2 className="card-title">Lixiviado de lombriz {p.litros}</h2>
                <p className="card-text">
                    <span className="label">Protección</span> contra rayos UV.
                </p>
                <p className="card-text">
                    <span className="label">Potenciador</span> de minerales.
                </p>
                <p className="card-text">
                    <span className="label">Enraizador</span> para tus plantas.
                    </p>
                <p className="card-text">
                    <span className="label">Rinde</span> hasta {p.rinde} (100 ml por litro de agua).
                    </p>
                </div>
            </div>
        ))}
      </div>

      <div className="product-footer">
        <h3 className="footer-title">Solicita tu entrega a domicilio</h3>
        <a href="https://wa.me/525662849476" className="product-btn-call" target="_blank" rel="noopener noreferrer">
  Mensaje
</a>
      </div>
    </div>
  );
};

export default Product;